import { apiClient } from "../../shared/api/httpClient";

export async function listNotices({ unreadOnly = false } = {}) {
  const response = await apiClient.get("/notices/", { params: { unread_only: unreadOnly } });
  return response.data;
}

export async function markNoticeRead(noticeId) {
  const response = await apiClient.post(`/notices/${noticeId}/read/`);
  return response.data;
}

